import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Guards feature routes. By the time routing runs, the APP_INITIALIZER has
 * already resolved authentication, so in practice an active account exists.
 * This is a safety net: if somehow no account is present, kick off sign-in.
 */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  if (auth.activeAccount) {
    return true;
  }
  // No account — trigger the silent-then-interactive sign-in flow again.
  void auth.initialize();
  return false;
};
